import React, { useRef } from "react";
import EmojiDisplay from "./EmojiDisplay";
import { motion, useScroll, useTransform, useInView } from "framer-motion";

const FIRE_EMOJI = { key: "1f525", value: "🔥" };
const FIRE_MAN = { key: "1f6a8", value: "🚨" };

const FireAnim = () => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true });
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
    const scale = useTransform(scrollYProgress, [0, 0.5], [0.5, 1.9]);

    return (
        <div className="mt-[10em] pb-[20em]" ref={ref}>
            {inView && (
                <motion.div className="flex flex-row" style={{ scale }}>
                    <EmojiDisplay selectedEmoji={FIRE_EMOJI} />
                    <motion.div
                        initial={{ x: 300 }}
                        whileInView={{ x: 0 }}
                        transition={{ duration: 1.8, type: "spring" }}
                        className="ml-10"
                    >
                        {/* <span className="text-4xl sm:text-9xl select-none">🚒</span> */}
                        <EmojiDisplay selectedEmoji={FIRE_MAN} />
                        
                    </motion.div>
                </motion.div>
            )}
        </div>
    );
};

export default FireAnim;
